import AntdAvatar                         from 'antd/lib/avatar';
import { AvatarProps as AntdAvatarProps } from 'antd/lib/avatar';

export type AvatarProps = AntdAvatarProps;

const Avatar = (props: AvatarProps) => {

	return (
		<AntdAvatar
			{...props}
		/>
	);
};

export default Avatar;

export const AvatarGroup = AntdAvatar.Group;
